import { render, staticRenderFns } from "./ChartConfigurationXAxisSeriesInput.vue?vue&type=template&id=4c8e94f6&"
import script from "./ChartConfigurationXAxisSeriesInput.vue?vue&type=script&lang=ts&"
export * from "./ChartConfigurationXAxisSeriesInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports